const defaultClickEventObj = {
	event: 'widgetUserEvent',
	action: 'clicked',
	widgetName: 'ws-packages-options',
	widgetId: 'packages-options1',
	widgetState: 'default',
	value: undefined,
	fieldValue: undefined,
	formId: undefined,
	formEventId: undefined
};

export function trackEvent(eventData) {
	if (typeof window.jQuery === 'function') {
		window.jQuery(document).trigger('trackEvent', {
			...defaultClickEventObj,
			...eventData
		});
	}
}

export function togglePackageOptionsEvent(widgetName, widgetId) {
	const eventData = {
		widgetName,
		widgetId,
		element: 'Show package details link',
		elementCTA: 'Show All Package Items',
		result: 'Package details expanded'
	};
	return eventData;
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js